<template>
  <output
    v-if="hasNewVersion"
    aria-live="polite"
    class="block fixed top-0 left-0 right-0 z-[9999] bg-info text-fg-on-accent shadow-lg"
  >
    <div class="mx-auto max-w-[1400px] flex flex-wrap items-center gap-4 px-4 py-3">
      <font-awesome-icon
        :icon="['fal', 'rotate']"
        size="lg"
        class="flex-shrink-0"
      />
      <div class="flex-1 min-w-[200px]">
        <strong class="block text-sm">Ny versjon av applikasjonen er tilgjengelig</strong>
        <span class="text-xs opacity-95 leading-snug">
          Last inn på nytt for å bytte til ny versjon.
        </span>
      </div>
      <BaseButton
        type="primary"
        :flat="false"
        icon="rotate"
        @click="reloadNow"
      >
        Last inn nå
      </BaseButton>
    </div>
  </output>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useGlobalStore } from '@/store/storeGlobal';
import BaseButton from '@/components/BaseComponents/BaseButton.vue';

const globalStore = useGlobalStore();
const { hasNewVersion } = storeToRefs(globalStore);

function reloadNow () {
  globalThis.location.reload();
}
</script>
